import type { RouterNavigateFn } from '@w/react-router'
import { spaceTreeOptions } from '../db/spaces-queries'
import type { FlashcardsFeRouterCtx } from '../router/flashcards-fe.router-ctx'
import type { routeTree } from '../router/flashcards-fe.router'

/** Training belongs to the route workspace, including when another user owns it. */
export async function returnToTrainingEditor(ctx: FlashcardsFeRouterCtx, workspaceId: string, navigate: RouterNavigateFn<typeof routeTree>) {
  const resource = ctx.spaces.get(workspaceId)
  const pages = await resource.queryClient.fetchQuery(spaceTreeOptions(resource))
  let pageId = pages[0]?.id
  if (!pageId) {
    navigate({to:'/$workspaceId/spaces/$spaceId/pages',params:{workspaceId,spaceId:resource.space.id}})
    return
  }
  navigate({ to: '/$workspaceId/spaces/$spaceId/pages/$pageId', params: { workspaceId, spaceId: resource.space.id, pageId }, search: { nav: '1' } })
}
